import type { Event } from '@patsnap/tahiti-core/common/event';
import type { PatentBasicEntity } from '../types';

export const PatentBasicService = Symbol.for('PatentBasicService');

export interface PatentBasicService {
    readonly onOverLimit: Event<void>;

    getPatentBase(patentId: string): Promise<PatentBasicEntity>;
    getPatentDefaultOfAbst(patent: PatentBasicEntity): { lang: string, text: string };
    getPatentDefaultOfTitle(patent: PatentBasicEntity): { lang: string, text: string };
}
